import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material';
import { Title, Meta } from '@angular/platform-browser';

import { PaisService } from '../pais.service';

@Component({
  selector: 'app-listado',
  templateUrl: './listado.component.html',
  styleUrls: ['./listado.component.scss']
})
export class ListadoComponent implements OnInit {

  name: string;
  paises = [];
  filteredItems = [];
  loading = {
    paises: true
  };
  share = {
    facebook: ''
  };
  buscar = false;
  constructor(
    private paisService: PaisService,
    private router: Router,
    private snackBar: MatSnackBar,
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) document: any) { }

  getBackgroundImageStyle(pImageUrl: string) {
    return {
      'background-image': 'url(' + pImageUrl + ')',
      'background-size': 'cover',
      'background-repeat': 'no-repeat'
    }
  }

  assignCopy() {
    this.filteredItems = Object.assign([], this.paises);
  }

  filterItem(value) {
    if (!value) {
      this.assignCopy();
    } else if (value.length > 3) {
      this.loading.paises = true;

      this.filteredItems = Object.assign([], this.paises).filter(
        item => item.NAME.toLowerCase().indexOf(value.toLowerCase()) > -1 || item.ID.toLowerCase().indexOf(value.toLowerCase()) > -1
      );

      this.loading.paises = false;

      this.snackBar.open('paises (' + this.filteredItems.length + ')', 'busqueda', {
        duration: 500,
      });
    }
  }

  getPaises() {
    this.loading.paises = true;
    this.paisService
      .getPaises()
      .subscribe((data: any) => {
        
        this.paises = data.response;
        this.loading.paises = false;
        this.assignCopy();
      });
  }

  gotoCountry(pCountry: any) {
    this.router.navigate(['/pais/species/' + pCountry + '/es']);
  }

  ngOnInit() {
    this.getPaises();
    this.share.facebook = document.location.href;
    this.titleService.setTitle('Paises/GlobalBirdWatching.org');

    this.metaService.updateTag({ property: 'og:url', content: document.location.href });
    this.metaService.updateTag({ property: 'og:type', content: 'website' });
    this.metaService.updateTag({ property: 'og:title', content: 'Listado de Paises GlobalBirdWatching.org' });
    this.metaService.updateTag({ property: 'og:description', content: 'GlobalBirdWatching.org - Listado de Paises' });
    this.metaService.updateTag({ property: 'og:image', content: 'https://images.globalbirdwatching.org/images/globalbirdwatching.png' });

    this.share.facebook += '?type=website&title=' + 'Listado de Paises GlobalBirdWatching.org' + '&description=' + 'GlobalBirdWatching.org - Listado de Paises' + '&image=https://images.globalbirdwatching.org/images/globalbirdwatching.png';
  }

}
